const { fetchUser } = require("./auth/auth.service");
const Parse = require("./parse.service");
const Profile = Parse.Object.extend("Profile");

//update the profile data based on profile Id
const updateProfile = async (userDetails) => {
  try {
    const currentUser = fetchUser();
    const query = new Parse.Query(Profile);
    query.equalTo("userId",currentUser);
    
    const currentUserEmail = currentUser?.get("email");

    if (userDetails?.email) {
      if (currentUserEmail !== userDetails?.email) {
        currentUser.set("email", userDetails?.email);
        await currentUser.save();
      }
    }

    const profile = await query.first();
    profile.set("address", userDetails?.address);
    profile.set("phone", userDetails?.phone);
    profile.set("country", userDetails?.country);
    profile.set("dateOfBirth", userDetails?.dateOfBirth);
    profile.set("firstname", userDetails?.firstname);
    profile.set("lastname", userDetails?.lastname);
    profile.set("gender", userDetails?.gender);
    const updatedProfile = await profile.save();
    return updatedProfile;
  } catch (error) {
    console.error("updating Profile Error ", error);
    return error;
  }
};

//get user profile data based on current user Profile Id
const getProfileData = async () => {
  try {
    const query = new Parse.Query(Profile);
    query.equalTo("userId",fetchUser())
    const res = await query.first()
    return  res;
  } catch (error) {
    throw error;
  }
};

//method to delete user account and user profile data
const deleteAccount = async () => {
  try {
    const currentUser = Parse.User.current();

    //deleting user profile data
    const profileQuery = new Parse.Query(Profile);
    profileQuery.equalTo("userId",currentUser);
    const profile = await profileQuery.first();

    //deleting user profile
    await profile.destroy();

    //deleting user account
    await currentUser.destroy();
  } catch (error) {
    console.error("delete Account error ", error);
  }
};

module.exports = { updateProfile, getProfileData, deleteAccount }